"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueLink = exports.List = exports.ListItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const ListItem = props => (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ as: "li" }, { children: props.children }));
exports.ListItem = ListItem;
exports.List = ui_react_1.styled.ul `
    list-style: disc;
    padding-left: 25px;
`;
exports.BlueLink = ui_react_1.styled.a `
    text-decoration: none;
    color: ${props => props.theme.colors.azure};
    font-weight: 600;
`;
//# sourceMappingURL=troubleshooting_list_items.js.map